<template>
  <div class="task-create-page">
    <div class="relative mx-auto">
      <div>
        <div class="cstm-unique-tab inner-tab">
          <div
            class="con-ul-tabs flex px-4"
            style="
              border-radius: 8px;
              border-top: 4px solid rgba(var(--vs-primary), 1);
            "
          >
            <div
              v-if="checkCreatePermission()"
              class="tab-name"
              :class="{ activeTab: task }"
              @click="mainTab('task')"
            >
              Task
            </div>
            <div
              v-if="
                checkProjectCreatePermission() || checkProjectEditPermission()
              "
              class="tab-name"
              :class="{ activeTab: project }"
              @click="mainTab('project')"
            >
              Project
            </div>
          </div>
        </div>
        <div class="cstm-unique-tab inner-tab">
          <div class="con-slot-tabs">
            <!-- Task Tab -->
            <div
              class="each-tabular p-4"
              v-if="task && checkCreatePermission()"
            >
              <div class="cstm-unique-tab-text">
                <vs-row vs-w="12" class="px-2">
                  <vs-col vs-w="6" class="task-main-info">
                    <h4 class="header-text"><b>Create Task</b></h4>
                    <div class="flex my-2">
                      <div class="md:w-2/3 w-full pr-4">
                        <vs-input
                          class="w-full"
                          label="Task Name"
                          v-model="taskData.name"
                          placeholder="Enter Task Name"
                        />
                      </div>
                      <div class="md:w-1/3 w-full">
                        <label for="" class="vs-input--label">Priority</label>
                        <v-select
                          v-model="taskData.task_priority_id"
                          v-validate="'required'"
                          :reduce="(option) => option.id"
                          label="level"
                          name="level"
                          :options="priority"
                          placeholder="Choose Priority"
                          style="width: 100%"
                        />
                      </div>
                    </div>
                    <div class="w-full my-2">
                      <label for="" class="vs-input--label">Details</label>
                      <vs-textarea
                        class="mb-0"
                        v-model="taskData.details"
                        label="Enter Details"
                      />
                    </div>
                    <div class="flex my-2">
                      <div class="md:w-1/2 w-full pr-2">
                        <label for="" class="vs-input--label"
                          >Responsible Person</label
                        >
                        <div class="cstm-inp flex-wrap">
                          <span
                            class="task-cstm-badge flex items-center mb-2"
                            :key="index4"
                            v-for="(person, index4) in responsibleData"
                          >
                            <img
                              v-if="person.picture != ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              :src="person.picture"
                            />
                            <img
                              v-if="person.picture == ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              src="@/assets/images/pages/user-circle-solid.svg"
                            />
                            {{ person.first_name }} {{ person.last_name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('Responsible', index4)"
                            />
                          </span>
                          <a
                            v-if="responsibleData.length == 0"
                            class="cursor-pointer person-add-button"
                            @click="addMoreUser('Responsible')"
                            >+ Add</a
                          >
                        </div>
                      </div>
                      <div class="md:w-1/2 w-full pl-2">
                        <label for="" class="vs-input--label">Deadline</label>
                        <flat-pickr
                          class="cstm-datepicker w-full"
                          placeholder="Select Date"
                          v-model="taskData.due_date"
                          @input="updateCalendar"
                          :config="configdateTimePicker1"
                        />
                      </div>
                    </div>
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-tabs class="inner-tab task-info-tabs">
                      <vs-tab
                        label="Checklist"
                        icon-pack="feather"
                        icon="icon-list"
                      >
                        <div
                          :key="index3"
                          v-for="(checklistRow, index3) in checklistRows"
                        >
                          <div class="md:flex flex-nowrap items-center">
                            <vs-input
                              label="Checklist Name"
                              placeholder="Enter checklist name"
                              v-model="checklistRow.name"
                              style="width: 100%"
                            />
                          </div>

                          <!-- <ul class="checklist-ul task-checklist mb-4 m-0">
                            <draggable
                              :list="checklistRow.items"
                              @change="statusLog"
                              class="w-full p-2"
                              handle=".handle1"
                            >
                              <li
                                class="flex justify-between"
                                :key="index6"
                                v-for="(item, index6) in checklistRow.items"
                              >
                                <div class="flex items-center">
                                  <span
                                    class="
                                      material-icons-outlined
                                      simple_drag_icon
                                      handle1
                                    "
                                    >drag_indicator</span
                                  >
                                  <vs-checkbox
                                    v-model="item.is_completed"
                                    @change="
                                      changeStatusFromCheck(index3, index6)
                                    "
                                  ></vs-checkbox>
                                  <span v-html="replaceURLs(item.todo)"></span>
                                </div>
                                <div class="flex">
                                  <vs-button
                                    color="warning"
                                    @click="
                                      editItemFromCheck(index3, index6, item)
                                    "
                                    icon-pack="feather"
                                    icon="icon-edit"
                                    type="flat"
                                  ></vs-button>
                                  <vs-button
                                    color="danger"
                                    @click="deleteItemFromCheck(index3, index6)"
                                    icon-pack="feather"
                                    icon="icon-trash-2"
                                    type="flat"
                                  ></vs-button>
                                </div>
                              </li>
                            </draggable>
                          </ul> -->
                          <div
                            class="checklist-item-list"
                            v-if="checklistRow.showTextBox.length"
                          >
                            <div
                              class="flex justify-between mt-4"
                              :key="index2"
                              v-for="(
                                testBox, index2
                              ) in checklistRow.showTextBox"
                            >
                              <span class="material-icons">drag_indicator</span>
                              <vs-input
                                class="inputx w-full"
                                placeholder="Type and enter to create item"
                                v-model="testBox.itemName"
                                @keyup.native.enter="
                                  submitItem(index3, checklistRow)
                                "
                              />
                              <vs-button
                                color="danger"
                                icon-pack="feather"
                                icon="icon-trash-2"
                                type="flat"
                                @click="removeItem(checklistRow, index2)"
                              ></vs-button>
                            </div>
                          </div>
                          <div
                            class="flex flex-wrap justify-between items-center"
                          >
                            <a
                              style="padding-bottom: 2px"
                              class="cursor-pointer"
                              @click="addItem(checklistRow)"
                              >+ Add Item</a
                            >
                            <!-- <vs-button  @click="addItem(checklistRow)">+ Item</vs-button> -->
                            <a
                              style="color: #ea5455"
                              class="cursor-pointer"
                              @click="removeChecklist(index3)"
                              type="flat"
                              >Remove All</a
                            >
                          </div>
                          <vs-divider />
                        </div>
                        <vs-button class="p-2" @click="addChecklist"
                          >+ Add Checklist</vs-button
                        >
                      </vs-tab>
                      <vs-tab
                        label="Created By"
                        icon-pack="feather"
                        icon="icon-users"
                      >
                        <vs-input
                          v-if="userInfo.last_name === null"
                          label="Created By"
                          class="w-full mb-3"
                          :value="userInfo.first_name"
                          readonly
                        />
                        <vs-input
                          v-else
                          label="Created By"
                          class="w-full mb-3"
                          :value="
                            userInfo.first_name + ' ' + userInfo.last_name
                          "
                          readonly
                        />
                        <div class="mb-3">
                          <label for="" class="vs-input--label"
                            >Participants</label
                          >
                          <div class="flex flex-wrap">
                            <div class="cstm-inp flex-wrap">
                              <span
                                class="task-cstm-badge flex items-center"
                                :key="index4"
                                v-for="(person, index4) in participantData"
                              >
                                <img
                                  v-if="person.picture != ''"
                                  class="
                                    person-img
                                    rounded-full
                                    shadow-md
                                    cursor-pointer
                                    block
                                  "
                                  :src="person.picture"
                                />
                                <img
                                  v-if="person.picture == ''"
                                  class="
                                    person-img
                                    rounded-full
                                    shadow-md
                                    cursor-pointer
                                    block
                                  "
                                  src="@/assets/images/pages/user-circle-solid.svg"
                                />
                                {{ person.first_name }} {{ person.last_name }}
                                <feather-icon
                                  class="cursor-pointer"
                                  icon="XIcon"
                                  @click="closeSelected('Participants', index4)"
                                />
                              </span>
                              <a
                                class="
                                  font-bold
                                  cursor-pointer
                                  person-add-button
                                "
                                @click="addMoreUser('Participants')"
                                >+ Add</a
                              >
                            </div>
                          </div>
                        </div>
                        <div>
                          <label for="" class="vs-input--label"
                            >Observers</label
                          >
                          <div class="flex flex-wrap">
                            <div class="cstm-inp flex-wrap">
                              <span
                                class="task-cstm-badge flex items-center"
                                :key="index4"
                                v-for="(person, index4) in observerData"
                              >
                                <img
                                  v-if="person.picture != ''"
                                  class="
                                    person-img
                                    rounded-full
                                    shadow-md
                                    cursor-pointer
                                    block
                                  "
                                  :src="person.picture"
                                />
                                <img
                                  v-if="person.picture == ''"
                                  class="
                                    person-img
                                    rounded-full
                                    shadow-md
                                    cursor-pointer
                                    block
                                  "
                                  src="@/assets/images/pages/user-circle-solid.svg"
                                />
                                {{ person.first_name }} {{ person.last_name }}
                                <feather-icon
                                  class="cursor-pointer"
                                  icon="XIcon"
                                  @click="closeSelected('Observers', index4)"
                                />
                              </span>
                              <a
                                class="
                                  font-bold
                                  cursor-pointer
                                  person-add-button
                                "
                                @click="addMoreUser('Observers')"
                                >+ Add</a
                              >
                            </div>
                          </div>
                        </div>
                      </vs-tab>
                      <vs-tab
                        label="Time Planning"
                        icon-pack="feather"
                        icon="icon-clock"
                      >
                        <div class="flex">
                          <div class="md:w-1/2 w-full pr-4">
                            <label for="" class="vs-input--label"
                              >From Time</label
                            >
                            <div>
                              <flat-pickr
                                placeholder="Enter Time"
                                :config="configdateTimePicker"
                                v-model="taskData.from_time"
                                @on-close="checkWhenClose('from')"
                              />
                            </div>
                          </div>
                          <div class="md:w-1/2 w-full">
                            <label for="" class="vs-input--label"
                              >To Time</label
                            >
                            <div>
                              <flat-pickr
                                :config="configdateTimePicker"
                                v-model="taskData.to_time"
                                placeholder="Enter Time"
                                @on-close="checkWhenClose('to')"
                                :disabled="taskData.from_time == ''"
                              />
                            </div>
                          </div>
                        </div>

                        <vs-checkbox
                          v-model="taskData.is_tracking_active"
                          class="mt-5 ml-0"
                          >Time Tracking</vs-checkbox
                        >
                      </vs-tab>

                      <vs-tab
                        label="Project"
                        icon-pack="feather"
                        icon="icon-grid"
                      >
                        <div class="mb-3">
                          <label for="" class="vs-input--label">Projects</label>
                          <div>
                            <v-select
                              v-model="taskData.project"
                              class="w-full"
                              :reduce="(option) => option.id"
                              label="name"
                              name="name"
                              :options="projectList"
                              placeholder="Select Project"
                              @open="onOpenProject"
                              @close="onCloseProject"
                            >
                              <template #list-footer>
                                <li
                                  ref="loadProject"
                                  class="loader"
                                  v-show="projectListMeta.has_next"
                                >
                                  Loading more project...
                                </li>
                              </template>
                            </v-select>
                          </div>
                        </div>
                        <div class="mb-3">
                          <label for="" class="vs-input--label"
                            >Remind about task</label
                          >
                          <div>
                            <div
                              class="flex w-full"
                              :key="index"
                              v-for="(item, index) in reminderTime"
                            >
                              <flat-pickr
                                class="w-full"
                                :config="configdateTimePicker1"
                                v-model="item.reminder_time"
                                placeholder="Choose Date & Time"
                              />
                              <vs-button
                                class="cursor-pointer font-semibold ml-1"
                                type="flat"
                                @click="removeReminder(index)"
                                icon-pack="feather"
                                icon="icon-x-circle"
                                color="danger"
                              ></vs-button>
                            </div>
                            <a
                              class="cursor-pointer font-semibold block mt-2"
                              @click="addReminder"
                              >+ Reminder</a
                            >
                          </div>
                        </div>
                        <div class="flex flex-wrap items-center mb-3">
                          <label for="" class="vs-input--label">CRM</label>
                          <div class="cstm-inp flex flex-wrap">
                            <span
                              class="task-cstm-badge flex items-center"
                              :key="index8"
                              v-for="(crm, index8) in selectedCRMData"
                            >
                              {{ crm.lead_first_name }}
                              <feather-icon
                                class="cursor-pointer"
                                icon="XIcon"
                                @click="closeSelected('CRM', index8)"
                              />
                            </span>
                            <a
                              class="font-bold cursor-pointer person-add-button"
                              @click="addModal('CRM')"
                              >+ Add</a
                            >
                          </div>
                        </div>
                        <div
                          class="flex flex-wrap items-center mb-3"
                          v-if="selectedProjectsData.length <= 1"
                        >
                          <label for="" class="vs-input--label">SubTask</label>
                          <div class="cstm-inp flex flex-wrap">
                            <span
                              class="task-cstm-badge flex items-center"
                              :key="index8"
                              v-for="(task, index8) in selectedSubTaskData"
                            >
                              {{ task.name }}
                              <feather-icon
                                class="cursor-pointer"
                                icon="XIcon"
                                @click="closeSelected('subTask', index8)"
                              />
                            </span>
                            <a
                              class="font-bold cursor-pointer person-add-button"
                              @click="addModal('subTask')"
                              >+ Add</a
                            >
                          </div>
                        </div>
                        <div>
                          <label for="" class="vs-input--label">Tags</label>
                          <div class="w-full">
                            <v-select
                              append-to-body
                              class="w-full"
                              label="name"
                              taggable
                              :reduce="(option) => option.id"
                              :create-option="
                                (option) => ({
                                  id: option,
                                  label: option,
                                  name: option
                                })
                              "
                              :options="tagsList"
                              v-model="taskData.tags"
                              :clearable="false"
                              data-vv-name="name"
                              name="name"
                              multiple
                              placeholder="Type and Enter"
                            >
                            </v-select>
                          </div>
                        </div>
                      </vs-tab>
                      <vs-tab
                        label="Notes"
                        icon-pack="feather"
                        icon="icon-file"
                      >
                        <editor
                          :api-key="tinyMceApi"
                          v-model="taskData.comments"
                          :init="initializeTinyMce"
                        />
                      </vs-tab>
                    </vs-tabs>
                  </vs-col>
                  <vs-divider />
                  <div class="md:w-1/2 w-full my-2">
                    <vs-checkbox v-model="taskData.is_template" vs-value="1"
                      >Save this as a template</vs-checkbox
                    >
                  </div>
                </vs-row>
                <div class="my-2 text-right">
                  <vs-button
                    class="mx-2"
                    :disabled="!buttonActive"
                    @click="submitTaskData"
                    >Save</vs-button
                  >
                </div>
              </div>
            </div>
            <!-- Project Tab -->
            <div
              class="each-tabular p-4"
              v-if="
                project &&
                (checkProjectCreatePermission() || checkProjectEditPermission())
              "
            >
              <ProjectCreate
                :project_id="projectId"
                :projectIdForAddTask="projectDetailsId"
                :fromWhere="'createPage'"
                :selectedStatus="statusNameFromButton"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      classContent="popup-example"
      title="Edit Item"
      :active.sync="checklistEditPopup"
    >
      <vs-input
        placeholder="Type and enter to create item"
        v-model="editChecklistName"
        @keyup.native.enter="updateItemForCheck()"
        class="mt-5 w-full"
      />
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      :title="typeOfPersonTitle"
      :active.sync="popupresponse"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staff">
          <div class="tab-text">
            <vs-input
              v-if="currentPageUser == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchUserBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table v-model="selectedUsers" :data="userList">
                <!-- <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template> -->

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="person-img rounded-full shadow-md block"
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  >
                  </vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student">
          <div class="tab-text">
            <vs-input
              v-if="currentPageClient == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchClientBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table v-model="selectedClients" :data="clientList">
                <!-- <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template> -->

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addUser">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      :title="typeOfPersonTitle"
      :active.sync="popupActive"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staff">
          <div class="tab-text">
            <vs-input
              v-if="currentPageUser == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchUserBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedUsers" :data="userList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  >
                  </vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student">
          <div class="tab-text">
            <vs-input
              v-if="currentPageClient == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchClientBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedClients" :data="clientList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addUser">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add Project"
      :active.sync="popupActiveProj"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Project">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table
                multiple
                v-model="selectedProjects"
                :data="ListOfProject"
              >
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="meta.current_page > 1"
                    @click="showProj('minus')"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    v-if="meta.has_next"
                    @click="showProj('plus')"
                    icon-pack="feather"
                    icon="icon-chevron-right"
                  ></vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('project')"
        >Add</vs-button
      >
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add CRM"
      :active.sync="popupActiveCRM"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="CRM">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedCRM" :data="leadList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].lead_first_name">
                      {{ data[indextr].lead_first_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="leadMeta.current_page > 1"
                    @click="showCRM('minus')"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    v-if="leadMeta.has_next"
                    @click="showCRM('plus')"
                    icon-pack="feather"
                    icon="icon-chevron-right"
                  ></vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('CRM')">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add Sub Task"
      :active.sync="popupActiveSubTask"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Sub Task">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table
                multiple
                v-model="selectedSubTask"
                :data="parentTaskData"
              >
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="sub_meta.current_page > 1"
                    @click="showSubTask('minus')"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    v-if="sub_meta.has_next"
                    @click="showSubTask('plus')"
                    icon-pack="feather"
                    icon="icon-chevron-right"
                  ></vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('subTask')"
        >Add</vs-button
      >
    </vs-popup>
    <div v-if="isBrowseContent">
      <vs-popup
        fullscreen
        title="Browse Item"
        :active.sync="isBrowseContent"
        class="childImportPopUp browse_modal_item"
      >
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="true"
        ></import-browse-files-model>
        <div slot="footer"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { TaskProject } from './mixins/task-project.js'
import ProjectCreate from './project-create.vue'
import TaskProjectTable from './components/task-project-table.vue'
import { Project } from './mixins/project.js'
import TaskSummary from '../analytics/summeryTaskList'
import { GoogleAuthorization } from '@/mixins/common/GoogleAuthorization.js'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
export default {
  mixins: [TaskProject, Project, PermissionMiddleware, GoogleAuthorization],
  components: {
    vSelect,
    ProjectCreate,
    TaskProjectTable,
    TaskSummary,
    ImportBrowseFilesModel
  },
  data () {
    return {
      maximizeCard: true,
      cstmconfigdateTimePicker: {
        disable: []
      },
      projectDetailsId: '',
      statusNameFromButton: ''
    }
  },
  computed: {
    buttonActive () {
      if (
        this.responsibleData.length !== 0 &&
        this.taskData.name !== '' &&
        this.taskData.task_priority_id !== ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.checkPermissionForStaff()

  },
  async mounted () {
    this.checklistRows = [{
      name: '',
      showTextBox: [],
      items: [],
      itemStatusCal: []
    }]
    this.fetchProject(this.meta)
    if (
      (this.checkProjectCreatePermission() || this.checkPermissionForStaff()) &&
      !this.checkCreatePermission()
    ) {
      this.mainTab('project')
    }
    this.mainTab(this.$route.params.payload.CreateType)
    if (
      Object.keys(this.$route.params.payload).length !== 0 &&
      this.$route.params.payload.constructor === Object
    ) {
      if (this.$route.params.payload.project === true) {
        this.project = this.$route.params.payload.project
        this.task = false
        this.projectId = this.$route.params.payload.projectId
        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.type = 'edit'
        queryPayload.id = this.projectId
        this.$router
          .replace({ name: 'project-create', query: queryPayload })
          .catch(() => { })
      } else {
        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.type = 'create'
        this.$router
          .replace({ path: '/tasks-project', query: queryPayload })
          .catch(() => { })
      }
    }
    this.file_repository_id = this.$store.getters.getRepoId
    this.userList = this.$store.getters.getGlobalUserList
    this.showButtonUser = this.$store.getters.getShowButtonUser
    this.currentPageUser = this.$store.getters.getCurrentPageUser
    this.clientList = this.$store.getters.getGlobalClientList
    this.currentPageClient = this.$store.getters.getcurrentPageClient
    this.showButtonClient = this.$store.getters.getShowButtonClient
    this.priority = this.$store.getters.getGlobalPriorityList
    this.tagsList = this.$store.getters.getGlobalTagList
    this.tag_meta = this.$store.getters.getTagMeta
    this.parentTaskData = this.$store.getters.getGlobalParentList
    this.sub_meta = this.$store.getters.getSubMeta
    this.ListOfTaskUpdate = this.$store.getters.getListOfTaskUpdate
    this.meta_template = this.$store.getters.getMetaTemplate
    this.ListOfLiveTaskUpdate = this.$store.getters.getListOfLiveTaskUpdate
    this.meta_task = this.$store.getters.getMetaTask
    this.ListOfProject = this.$store.getters.getListOfProject
    this.meta = this.$store.getters.getMeta
    this.leadList = this.$store.getters.getGlobalLeadList
    this.leadMeta = this.$store.getters.getLeadMeta
  }
}
</script>

<style lang="scss">
.userModalStyle {
  z-index: 100000;
}

.task-info-tabs {
  padding-top: 10px;
  padding-left: 20px;

  .con-ul-tabs {
    margin-top: unset;
  }

  .vs-tabs--li.activeChild .vs-tabs--btn {
    background: #3ac2d4;
    color: white !important;
    border-radius: 4px;
    padding: 10px;

    &:hover {
      color: white !important;
    }
  }

  .line-vs-tabs {
    display: none;
  }

  .vs-tabs--content {
    padding: 0;
    background: white;

    .material-icons {
      display: flex;
      align-items: center;
    }

    .flatpickr-input[type='hidden'] + input {
      width: 100%;
    }
  }

  .checklist-item-list {
    background: #e6f5f6;
    padding: 2px 0 16px;
    border-radius: 4px;
    margin: 6px 0;
  }
}

.task-main-info {
  padding-right: 5px;
  border-right: 1px solid #dbdbdb;

  .header-text {
    color: #555262;
    font-size: 24px;
    font-weight: 600;
  }
}

.task-create-page {
  .cstm-inp {
    margin: 0;
    padding: 0 7px;
  }

  .person-add-button {
    padding: 4px 8px;
    background: #d2eff3;
    border-radius: 4px;
  }

  .vs-input--label {
    color: #555262;
    font-weight: bold;
  }
}
</style>
